/**
 * 操作员授权位 —— backend `users/constants.py::GRANT_*` 的前端镜像。
 *
 * 值是跨端契约（与 role 数字 9/99/999 同一双端各自定义的模式）；
 * 判定语义统一住在 `shared/auth/access.ts`（admin 恒过）。
 */
export const GRANT = {
  /** 用户管理受限面：查询 + 核验，仅 USER 角色。 */
  userManagement: 1 << 0,
  /** 汇率报价工具页（/fx 读面）。 */
  fxQuotes: 1 << 1,
} as const;

export type GrantBit = (typeof GRANT)[keyof typeof GRANT];

/** 位从 bit0 连续分配 ⇒ 合法 mask 集就是 0..MAX 的整数区间（与后端共口径）。 */
export const GRANTS_MASK_MAX = GRANT.userManagement | GRANT.fxQuotes;

export const GRANT_OPTIONS = [
  {
    bit: GRANT.userManagement,
    labelKey: 'users.grants.userManagement',
    field: 'grants_userManagement',
  },
  { bit: GRANT.fxQuotes, labelKey: 'users.grants.fxQuotes', field: 'grants_fxQuotes' },
] as const;
